import { useApolloClient } from "@apollo/client";
import { Select, SelectProps } from "@cofano/cck";
import { GetFaqCategoriesDocument } from "__generated__/view/admin/graphql/admin.queries.generated";

export type AdminSupportCategorySelectOption = {
	id: number;
	name: string;
}

const AdminSupportCategorySelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<AdminSupportCategorySelectOption, Multiple>, "fetchOptions" | "getOptionLabel">) => {

	const client = useApolloClient();

	const onFetchOptions = async() => {
		const response = await client.query({
			query: GetFaqCategoriesDocument,
		});

		return {
			options: (response.data?.faqCategories ?? []).map(category => ({
				id: category.id ?? 0,
				name: category.name ?? "",
			})),
			totalResults: response.data?.faqCategories?.length ?? 0,
		};
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			getOptionLabel={option => option.name} />
	);
};

export default AdminSupportCategorySelect;
